// pages/LoginPage.tsx
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../Firebase/firebaseConfig';
import AuthForm from '../auth/AuthForm';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../redux/storage/store';
import { loginUser } from '../redux/slice/authSlice';

export default function LoginPage() {
    const dispatch = useDispatch<AppDispatch>();
  const handleLogin = async (email: string, password: string): Promise<void> => {
    try {
        const loggedinUser = await signInWithEmailAndPassword(auth, email, password);
        console.log(loggedinUser);
        dispatch(loginUser())
    } catch (error) {
        console.error(error);
    }
  };

  return <AuthForm onSubmit={handleLogin} type="login" />;
}
